export function slugify(str: string) {
  return str
    .substring(0, 100) // truncate
    .toLowerCase()
    .replace(/ /g, "-") // replace spaces with -
    .replace(/[^\p{Letter}\d-]+/gu, ""); // remove any non letter characters (supports unicode)
}

export function capitalizeFirstLetter(val: string) {
  if (val.length === 0) {
    return val;
  }
  return val.charAt(0).toUpperCase() + val.slice(1);
}

export function camelToSnakeCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function isString(data: any): data is string {
  return typeof data === "string";
}

export function processRoleLabel(label?: string | null) {
  if (!label) return "";
  return ["admin", "member", "team"].includes(label) ? capitalizeFirstLetter(label) : label;
}
